import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-status',
  templateUrl: './dialog-status.component.html',
  styleUrls: ['./dialog-status.component.sass']
})
export class DialogTransactionStatusComponent implements OnInit {
  comment: string;

  constructor(
    public dialogRef: MatDialogRef<DialogTransactionStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  onConfirm(comment) {
    if (comment) {
      this.dialogRef.close(comment);
    }
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
